<template>
  <div class="message-form-container">
    <slot />
    <textarea
      v-model="form.content"
      class="zord-form-control"
      :form="formId"
      rows="5"
      name="message[content]"
      :placeholder="t('questions.type_response')"
      required="true"
      maxlength="650"
    />

    <zord-button
      :form="formId"
      :label="t('links.send')"
      is-primary
      type="submit"
      style="align-self: flex-start;"
      :disabled="form.content.length === 0"
    />
  </div>
</template>

<script>
import { t } from '@/javascripts/config/i18n'
import { ZordButton } from '@/javascripts/components/zord'

export default {
  name: 'MessageForm',
  data() {
    return {
      t,
      form: {
        content: ''
      },
    }
  },
  props: {
    formId: {
      type: String,
      default: ''
    },
    messageSender: {
      type: String,
      defautl: ''
    }
  },
  components: {
    ZordButton,
  },
  methods: {
    handleMessageCreation() {
      const messagesContainer = document.querySelector('.messages-container')
      const scrollOptions = {
        top: messagesContainer.scrollHeight,
        left: 0,
        behavior: 'smooth'
      }

      messagesContainer.scrollTo(scrollOptions);
      this.form.content = '';
    },
  },
  mounted() {
    document.addEventListener('onMessageCreate', this.handleMessageCreation)
  },
  beforeUnmount() {
    document.removeEventListener('onMessageCreate', this.handleMessageCreation);
  }
}
</script>

<style lang="scss" scoped>
  .message-form-container {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
  }

</style>
